import _ from 'underscore'
import React from 'react'
import styled from 'styled-components'

import Tabs, { Tab } from 'components/Tabs'

import DeviceLegacy from 'pages/Device/indexLegacy'
import Device from 'pages/Device/index'

import DeviceTabHeader from 'pages/shared/DeviceTabs/DeviceTabHeader'

import { DeviceBase } from 'types/Device'

import { screenSize } from 'styles/shared'
import { useFeaturesContext } from 'hooks/FeaturesContext'

type Props = {
  customerName?: string
  devices: Array<DeviceBase>
  activeDeviceId: string
  onActiveDeviceChangeCallback: (deviceId: string) => void
  refreshPageCallback?: () => void
  className?: string
}

const DeviceTabs = ({ customerName, activeDeviceId, devices, onActiveDeviceChangeCallback, refreshPageCallback, className }: Props) => {
  const activeDevice = devices.find(r => r.deviceId === activeDeviceId)
  const activeDeviceIndex = activeDevice ? devices.indexOf(activeDevice) : 0
  const { enabledFeatures } = useFeaturesContext()

  const hasAlerts = (device) => {
    return device.majorAlertCount || device.minorAlertCount || device.criticalAlertCount || device.sdaMajorAlertCoun || device.sdaMinorAlertCount
  }

  const getDeviceDetails = (device) => {
    if (enabledFeatures.includes('system_dashboard')) {
      return (<Device
        deviceId={device.deviceId}
        dealerId={device.dealerId}
        isActive={device.deviceId === activeDeviceId}
        refreshPageCallback={refreshPageCallback}
              />)
    } else {
      return (<S.DeviceLegacy
        deviceId={device.deviceId}
        dealerId={device.dealerId}
        isActive={device.deviceId === activeDeviceId}
        refreshPageCallback={refreshPageCallback}
              />)
    }
  }

  return (
    <div className={className}>
      <Tabs
        tabpage={'device'}
        activeTabIndex={activeDeviceIndex}
        onSelectTabIndexCallback={(index) => onActiveDeviceChangeCallback(devices[index].deviceId)}
        tabItems={
          _.map(devices, r => {
            const item: Tab = {
              key: r.deviceId,
              alerts: hasAlerts(r),
              header: <DeviceTabHeader
                        customerName={customerName}
                        device={r}
                        isActive={r.deviceId === activeDeviceId}
                      />,
              details: getDeviceDetails(r)

            }

            return item
          })
        }
      />
    </div>
  )
}

export default DeviceTabs

const S = {
  DeviceLegacy: styled(DeviceLegacy)`
    padding: 0 20px;

    @media ${screenSize.small} {
      padding: 0;
    }
  `
}
